import { createApiClient } from '@mustauto/utils/api-client';
import { signOut } from 'firebase/auth';
import { getFirebaseAuth } from './firebase';

export const api = createApiClient({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  getToken: async (forceRefresh?: boolean) => {
    const auth = getFirebaseAuth();
    // Boot race: requests podem disparar antes do Firebase restaurar a
    // sessão do storage — sem isso, saem sem token e tomam 401 indevido.
    await auth.authStateReady();
    const user = auth.currentUser;
    return user ? user.getIdToken(forceRefresh) : null;
  },
  // Impersonation do backoffice: header extra por request quando ativo.
  getExtraHeaders: () => {
    const impersonationToken = sessionStorage.getItem('impersonationToken');
    const headers: Record<string, string> = {};
    if (impersonationToken) headers['X-Impersonation-Token'] = impersonationToken;
    return headers;
  },
  onUnauthorized: async () => {
    // Impersonation expirada não pode derrubar a sessão REAL do admin:
    // descarta o token de impersonation e recarrega na sessão própria.
    if (sessionStorage.getItem('impersonationToken')) {
      sessionStorage.removeItem('impersonationToken');
      window.location.reload();
      return;
    }
    try {
      await signOut(getFirebaseAuth());
    } catch {
      // segue para o redirect mesmo se o signOut falhar
    }
    window.location.assign('/login');
  },
});
